export const EPISODE = 'episode'
export const AD = 'ad'
export const PODCAST = 'podcast'
export const BUTTON = 'button'
export const STREAMDURATION = 'streamedDuration'
export const STREAM = 'stream'



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/model/constants/DataType.js